export interface AddRfcDialogDataInterface {
  existingMadCode: string[];
}

export class AddRfcDialogData implements AddRfcDialogDataInterface {
  constructor(
    public existingMadCode: string[],
  ) {}
}
